export const videoCallSurfaceClassName = "bg-muted/60 text-foreground";

export const videoCallOverlayClassName =
  "border border-border/60 bg-card/90 text-foreground shadow-sm backdrop-blur-sm";

export const videoCallMutedOverlayClassName = "bg-muted text-muted-foreground";

export const videoCallStatusPillClassName =
  "rounded-full border border-border/60 bg-card/90 px-3 py-1.5 text-sm font-medium text-foreground shadow-sm backdrop-blur-sm";

export const videoCallPanelClassName =
  "rounded-xl border border-border/60 bg-card/90 shadow-sm";

export const videoCallDestructiveControlClassName =
  "border border-destructive/40 bg-destructive/15 text-destructive hover:bg-destructive/25";

export const videoCallControlClassName =
  "border border-border/60 bg-card text-foreground hover:bg-accent hover:text-accent-foreground";
